import { DateFormatError, HUMAN_DATE_FORMAT } from '@Constants/date'
import { type DateFormat } from '@Types/date'
import { parseHumanDateToISOLocalDate, parseISOToHumanDate } from '@Utils/date'

const isHumanDateFormat = (dateFormat: DateFormat): boolean => dateFormat === HUMAN_DATE_FORMAT

export const getFormattedDate = (dateStr: string, dateFormat: DateFormat): string => {
  const isHumanFormattedDate = isHumanDateFormat(dateFormat)

  if (!isHumanFormattedDate) {
    return dateStr
  }

  const formattedDate = parseHumanDateToISOLocalDate(dateStr)

  if (formattedDate === DateFormatError.INVALID_HUMAN_DATE) {
    return dateStr
  }

  return formattedDate
}

export const getValue = (dateStr: string, dateFormat: DateFormat): string => {
  const isHumanFormattedDate = isHumanDateFormat(dateFormat)

  if (!isHumanFormattedDate) {
    return dateStr
  }

  const formattedDate = parseISOToHumanDate(dateStr)

  if (formattedDate === DateFormatError.INVALID_ISO_DATE) {
    return dateStr
  }

  return formattedDate
}
